import type { FaireProductEntity } from "../../entity_types/product";

export const p_ud2nk2w92u: FaireProductEntity = {
  token: "p_ud2nk2w92u",
  type: "product",
  name: "Respect The Locals Banner – Vintage Felt Flag",
  brandToken: "b_c967u6a4",
  brandName: "Benoit's Design Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/0f739ae40f5899f52d043c92b54fd07bf18905098fb3f471c77046cd74ec2add.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/afa7efee1893ad55f7b11665eb873dafa4daba976aee32ed5222b1e644adb22a.jpeg",
    "https://cdn.faire.com/fastly/42abef028a9a0e2fe71edb6e38b85be7ae0ba41976eba9c1edf9dbad16a97273.jpeg",
    "https://cdn.faire.com/fastly/e10a37e84d3396b1f4e39c0dba8e9fc6a0915090a1a91734dffab8df83026d3f.jpeg",
    "https://cdn.faire.com/fastly/bae4e5c7f9d6bc9fa89e84e743a90d2af0480438a03af5cc662f45274f66688f.jpeg",
  ],
  priceDollars: 21,
  description:
    "The Respect The Locals Banner is a vintage felt banner designed to celebrate wildlife and inspire outdoor adventure. Measuring 8x40 inches, this handmade felt flag features classic vintage typography printed directly onto a solid piece of felt, creating a durable and eye-catching outdoor adventure flag. Perfect as nature wall decor or a leave no trace sign, this banner brings rustic camping decor charm to any cabin or woodland cabin banner space. Crafted in Maine, USA, each wildlife themed pennant includes four brass grommets for easy hanging and long-lasting use.\n\n\nThis outdoor lover gift serves as both a hiking wall hanging and cabin art decoration, reminding you to respect the wild neighbors while enhancing your space with authentic handmade felt flag quality.",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:40.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
